import {
  compose, hoistStatics,
} from 'recompose';
import Input from './input';

const enhance = compose();
export default hoistStatics(enhance)(Input);
